import { useState, useEffect } from 'react'
import { Container, Row, Col } from 'reactstrap'
import s from './HtmlProposalLibrary.scss'
import cn from 'classnames'
import { makeGetRequest } from 'utils/api'

const HtmlProposalLibrary = ({
  predesignedTemplates,
  setLeftSelectedIndexCb,
  setMiddleSelectedIndexCb,
  setTemplateOptionsCb
}) => {
  const [leftSelectedIndex, setLeftSelectedIndex] = useState('')
  const [middleSelectedIndex, setMiddleSelectedIndex] = useState('')
  const [templateOptions, setTemplateOptions] = useState([])
  const [templateOptionDetails, setTemplateOptionDetails] = useState(null)

  useEffect(() => {
    ;(async () => {
      if (!predesignedTemplates[leftSelectedIndex]?.id) return
      const response = await makeGetRequest(
        `/v1/templateimages/thumbs?folder=${predesignedTemplates[leftSelectedIndex].title}`
      )
      setTemplateOptions(response)
      setTemplateOptionsCb(response)
      setMiddleSelectedIndex('')
      setTemplateOptionDetails(null)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leftSelectedIndex])

  useEffect(() => {
    ;(async () => {
      if (!templateOptions[middleSelectedIndex]?.name) return
      const response = await makeGetRequest(
        `/v1/templateimages/covers?folder=${predesignedTemplates[leftSelectedIndex].title}&thumb=${templateOptions[middleSelectedIndex].name}`
      )
      setTemplateOptionDetails(response)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [middleSelectedIndex])

  return (
    <Container style={{ height: '100%' }}>
      <Row style={{ height: '100%' }}>
        <Col style={{ height: '100%' }} lg="3">
          <h6>Select a Layout to view all options</h6>
          <div className={s.leftWrapper}>
            {predesignedTemplates
              .filter(template => template.thumbnailUrl)
              .map((template, index) => (
                <img
                  key={template.id}
                  src={template.thumbnailUrl}
                  className={cn(s.leftThumb, {
                    [s.selected]: leftSelectedIndex === index
                  })}
                  onClick={() => {
                    setLeftSelectedIndex(index)
                    setLeftSelectedIndexCb(index)
                  }}
                />
              ))}
          </div>
        </Col>
        <Col style={{ height: '100%' }} lg="6">
          {templateOptions.length ? (
            <>
              <h6>Select an option</h6>
              <div className={s.leftWrapper}>
                {templateOptions
                  .filter(template => template.url)
                  .map((template, index) => (
                    <img
                      key={template.name}
                      src={template.url}
                      className={cn(s.middleThumb, {
                        [s.selected]: middleSelectedIndex === index
                      })}
                      onClick={() => {
                        setMiddleSelectedIndex(index)
                        setMiddleSelectedIndexCb(index)
                      }}
                    />
                  ))}
              </div>
            </>
          ) : (
            <div className={s.noOptions}>
              <p>Select a layout to view all options</p>
            </div>
          )}
        </Col>
        <Col style={{ height: '100%', overflowY: 'auto' }} lg="3">
          {templateOptionDetails?.[0] && (
            <>
              <h6>{templateOptionDetails[0].name}</h6>
              <span>Images, sections and pages can be edited, added or deleted.</span>
              <img src={templateOptionDetails[0].url} className={s.details} />
            </>
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default HtmlProposalLibrary
